/*
 * @Description: 拦截器
 * @Author: jie.yin
 * @Date: 2021-09-02 15:36:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-14 11:52:34
 */
import axios from 'axios'

// create an axios instance
const service = axios.create({
  timeout: 60000 // request timeout
})

/**
 * 混合拦截请求参数
 */
// const CancelToken = axios.CancelToken
// const source = CancelToken.source()

// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      return Promise.reject(response.status)
    }

    if (/\.json$/.test(response.config.url)) {
      return response.data
    }

    const errCode = response.data.code
    if (errCode !== 0) {
      return Promise.reject(response.data)
    }
    return response.data.data
  },
  error => {
    return Promise.reject(error)
    // window.$msg.success(i18n.t('network_err'))
    // console.error(error.message)
    // return Promise.reject(error)
  }
)

export default service
